import React from 'react';
import HelpLink from 'components/pure/admin/HelpLink';

export default class ScorecardFormDialogHelp extends React.PureComponent {
  render() {
    return (
      <HelpLink popoverClassName={'department-profile-help-text'}>
        <p>
          Enter one or more questions for this scorecard. Each question will be presented to the
          user with a choice of scores depending on the chosen scoring scheme.
        </p>
        <p>
          The possible scoring schemes are:
          <ul>
            <li>1 to 5 - showing scores 1 to 5 where 1 is "Not at all" and 5 is "Completely"</li>
            <li>1 to 3 - showing scores 1 to 3 where 1 is "Not at all" and 3 is "Completely"</li>
            <li>Yes/No - showing scores "yes" and "no"</li>
            <li>Pass/Fail - showing scores "pass" and "fail"</li>
          </ul>
        </p>
        <p>Write your questions in such a way to fit this style of answering.</p>
        <p>Drag and drop questions if you wish to reorder them</p>
        <p>Click on the trash icon to the right of a question to remove it from the scorecard</p>
        <p>Click "Add a Question" to add a new question.</p>
        <p>Once you are happy with the questions, click "Save" to save your changes.</p>
      </HelpLink>
    );
  }
}
